export function SectionConsultas() {
  return (
    <section className="section section-consultas">
      <div className="container">
        <picture>
          <source src="img/preguntas_frecuentes/banner-movil.jpg" media="(max-width: 768px)" />
          <img src="img/preguntas_frecuentes/banner.jpg" className="consultas-banner" />
        </picture>
        <article className="consultas-cards">
          <div className="consultas-card">
            <img src="img/preguntas_frecuentes/consulta-1.png" alt="" />
            <h3>Visita un Comercio <br /> Afiliado</h3>
            <p>
                <span>Horario de atención:</span><br/>
                <span>Lun - Dom: 10 am - 10 pm</span>
            </p>
          </div>
          <div className="consultas-card">
            <img src="img/preguntas_frecuentes/consulta-2.png" alt="" />
            <h3>Escríbenos al <br />
              <img
                src="img/whatsapp.png"
                alt="whatsapp"
                style={{ display: "inline-block", width: "30px", marginRight: "8px", verticalAlign: "middle", margin: "0" }}
              /> +51 967421523</h3>
              <p>
                <span>Horario de atención:</span><br/>
                <span>Lun - Vie: 9am - 6pm</span><br/>
                <span>Sab - Dom: 9am - 12pm</span>
              </p>
          </div>

          <div className="consultas-card" style={{ textAlign: "center" }}>
            <img src="img/preguntas_frecuentes/consulta-3.png" alt="" />

            <h3
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                margin: "16px 0",
                textAlign: "center"
              }}
            >
              <img
                src="img/whatsapp.png"
                alt="whatsapp"
                style={{
                  width: "28px",
                  height: "28px",
                  verticalAlign: "middle"
                }}
              />
              <span>
                Chatea con <br /> un asesor
              </span>
            </h3>

            <p>Te ayudamos a resolver tus <br /> dudas o consultas.</p>
          </div>


          <div className="consultas-card">
            <img src="img/preguntas_frecuentes/consulta-4.png" alt="" />
            <h3>Escríbenos <br />
              <a href="mailto:servicioalcliente@miscuotas.com">servicioalcliente@miscuotas.com</a></h3>
            <p>Te responderemos lo más pronto <br />
              posible para poder ayudarte.</p>
          </div>
        </article>
      </div>
    </section>
  )
}